function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './CustomerCareSection.css';
import React, { useContext } from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import CustomerCareCard from './CustomerCareCard';
const ContactSection = props => {
  const {
    item: {
      leftTitle,
      rightTitle,
      leftItems,
      rightItems
    }
  } = props;
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  return /*#__PURE__*/React.createElement("div", {
    className: `contact-section row ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, leftItems.items.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "contact-section__col col-12 col-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "contact-section__group "
  }, leftTitle.jss.value && /*#__PURE__*/React.createElement("h2", {
    className: "contact-section__heading"
  }, leftTitle.jss.value), /*#__PURE__*/React.createElement("div", {
    className: "contact-section__cards"
  }, leftItems.items.map((item, index) => {
    return /*#__PURE__*/React.createElement(CustomerCareCard, _extends({
      key: index
    }, item));
  })))), rightItems.items.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "contact-section__col col-12 col-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "contact-section__group"
  }, rightTitle.jss.value && /*#__PURE__*/React.createElement("h2", {
    className: "contact-section__heading"
  }, rightTitle.jss.value), /*#__PURE__*/React.createElement("div", {
    className: "contact-section__cards"
  }, rightItems.items.map((item, index) => {
    return /*#__PURE__*/React.createElement(CustomerCareCard, _extends({
      key: index
    }, item));
  })))));
};
export default ContactSection;
const commonStyles = "c1ef900m";
const ltrStyles = "lrnaw41";
const rtlStyles = "r1djth6h";